<template>
  <van-popup v-model="visible" position="bottom" :style="{ height: '100%' }" @close="hidePopup">
    <van-nav-bar
      :title="title"
      left-text="取消"
      right-text="保存"
      @click-left="hidePopup"
      @click-right="sureFn"
    />
    <slot />
  </van-popup>
</template>
<script>
import api from '@/api'
import { img2String } from '@/utils/tool'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'create'
    },
    initFormData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  watch: {
    initFormData: {
      handler(newV) {
        // console.log(newV)
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    img2String,
    hidePopup() {
      this.$emit('update:visible', false)
      this.$emit('close', false)
    },
    submitFormSuccess(flag = true) {
      this.$emit('submitFormSuccess', flag)
    },
    sureFn() {
      const form = {
        ...this.initFormData,
        businessPic: this.img2String(this.initFormData.businessPic),
        pic: this.img2String(this.initFormData.pic),
        productPic: this.img2String(this.initFormData.productPic),
        uscPic: this.img2String(this.initFormData.uscPic),
        epidemicPic: this.img2String(this.initFormData.epidemicPic)
      }
      api.updateCompany(form).then(res => {
        this.$toast.success(res.msg)
        this.hidePopup()
        this.submitFormSuccess()
      })
    }
  }
}
</script>
